import React from 'react';
import { Imgcomponent } from '@tbx/experience-widgets-lib';
import useBrandInfo from '../../customHooks/useBrandInfo';
import './styles.scss';
import { useTranslation } from 'react-i18next';
import useClientConfigs from '../../customHooks/useClientConfigs';

export default function ExtendedFooter() {
  const { t } = useTranslation();
  const [openMenu, setOpenMenu] = React.useState(null); // 'aliados' | 'corporativo' | null
  const BRAND_INFO = useBrandInfo();
  const currentYear = new Date().getFullYear();
  const { partnerPortals, corporateSection } = useClientConfigs();

  const toggleMenu = (key) => {
    setOpenMenu((prev) => (prev === key ? null : key));
  };

  return (
    <footer className="footer__container">
      <div className="flex">
        <div className="flex-footer">
          {/* Logo */}
          <div className="footer__logo">
            <Imgcomponent
              className="logoFooter"
              src={'/images/logoWhite.svg'}
              alt={BRAND_INFO.CLIENT_NAME}
              loading={'eager'}
            />
          </div>

          {/* Networks social (Bootstrap Icons) */}
          <div className="footer__social" aria-label="Redes sociales">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.tiktok.com/@canalrcn"
              className="footer__social-icon"
              aria-label="TikTok"
            >
              <i className="bi bi-tiktok" />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/CanalRCN/"
              className="footer__social-icon"
              aria-label="Facebook"
            >
              <i className="bi bi-facebook" />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://x.com/CanalRCN"
              className="footer__social-icon"
              aria-label="X"
            >
              <i className="bi bi-twitter-x" />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/canalrcn/"
              className="footer__social-icon"
              aria-label="Instagram"
            >
              <i className="bi bi-instagram" />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.youtube.com/channel/UCSCAJJ1RJ4rfRTVW4gjYTpQ"
              className="footer__social-icon"
              aria-label="YouTube"
            >
              <i className="bi bi-youtube" />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.whatsapp.com/channel/0029Va4Xq8N9xVJbLTXCa81D"
              className="footer__social-icon"
              aria-label="WhatsApp"
            >
              <i className="bi bi-whatsapp" />
            </a>
          </div>
        </div>

        {/* Menús */}
        <div className="footer__menus">
          <div
            className={`footer__menu footer__menu--aliados ${openMenu === 'aliados' ? 'footer__menu--open' : ''}`}
          >
            <button
              className={`footer__menu-title js-toggle-menu ${openMenu === 'aliados' ? 'footer__menu-title--active' : ''}`}
              data-target="aliados"
              aria-expanded={openMenu === 'aliados'}
              aria-controls="menu-aliados"
              onClick={() => toggleMenu('aliados')}
            >
              {partnerPortals.sectionTitle}
              <i className="bi bi-chevron-down" />
            </button>

            <ul
              id="menu-aliados"
              className={`footer__menu-list ${openMenu === 'aliados' ? 'footer__menu-list--open' : ''}`}
            >
              {partnerPortals.links.map((item) => (
                <li key={item.href}>
                  <a target="_blank" rel="noopener noreferrer" href={item.href}>
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div
            className={`footer__menu footer__menu--corporativo ${openMenu === 'corporativo' ? 'footer__menu--open' : ''}`}
          >
            <button
              className={`footer__menu-title js-toggle-menu ${openMenu === 'corporativo' ? 'footer__menu-title--active' : ''}`}
              data-target="corporativo"
              aria-expanded={openMenu === 'corporativo'}
              aria-controls="menu-corporativo"
              onClick={() => toggleMenu('corporativo')}
            >
              {corporateSection.sectionTitle}
              <i className="bi bi-chevron-down" />
            </button>

            <ul
              id="menu-corporativo"
              className={`footer__menu-list ${openMenu === 'corporativo' ? 'footer__menu-list--open' : ''}`}
            >
              {corporateSection.links.map((item) => (
                <li key={item.href}>
                  <a target="_blank" rel="noopener noreferrer" href={item.href}>
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="footer__legal">
        <div className="flex-footer">
          <p>{`© ${currentYear} ${BRAND_INFO.CLIENT_NAME_FOOTER}`}</p>

          <p>{t('All rights reserved.')}</p>
        </div>

        <div className="footer__legal-links">
          <a target="_blank" rel="noopener noreferrer" href="/terminos-de-uso">
            {t('Terms of service')}
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/tratamientos-de-datos"
          >
            {t('Consumer protection')}
          </a>
          <a target="_blank" rel="noopener noreferrer" href="/privacidad">
            {t('Cookies policy')}
          </a>
        </div>
      </div>
    </footer>
  );
}
